<div class="ion-padding kreta-naploz">
  <h2><ion-icon name="book-outline"></ion-icon> KRÉTA naplózás</h2>
  <p class="halvany">
    Tanáronként a saját KRÉTA-belépésével beírja a Sulinformban <b>megtartott + témás</b> órákat és a
    <b>rögzített jegyeket</b> a KRÉTA e-naplóba – a KRÉTÁ-ban így a tanár neve látszik, nem az adminé.
    Először futtass <b>Tesztet</b> (nem ír), és csak utána élesben.
  </p>

  <!-- Automatikus KRÉTA-szinkron: csoporttagság + órarend ütemezve, a többi automatikus feladat állapota. -->
  <app-kreta-utemezo-kartya [intezmeny]="intezmeny"></app-kreta-utemezo-kartya>

  <!-- Belépés felvétele/szerkesztése -->
  <ion-card>
    <ion-card-header><ion-card-title>Tanár ↔ KRÉTA-belépés</ion-card-title></ion-card-header>
    <ion-card-content>
      <div class="racs">
        <ion-item>
          <ion-label position="stacked">Pedagógus keresése</ion-label>
          <ion-input placeholder="név vagy azonosító" [(ngModel)]="allomanySzuro"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Pedagógus</ion-label>
          <ion-select [(ngModel)]="form.allomany" (ionChange)="onAllomanyValt()" interface="popover" placeholder="Válassz tanárt">
            <ion-select-option *ngFor="let a of szurtAllomany" [value]="a.adid || a.id">{{ tanarNev(a) }} ({{ a.adid }})</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">KRÉTA felhasználónév</ion-label>
          <ion-input [(ngModel)]="form.kreta_user" placeholder="pl. blaha.monika"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">KRÉTA jelszó {{ form.allomany && hozzaferesekById(form.allomany) ? '(mentve – csak cseréhez töltsd ki)' : '' }}</ion-label>
          <ion-input type="password" [(ngModel)]="form.kreta_pass" placeholder="jelszó"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">TOTP secret (csak ha 2FA-s a fiók)</ion-label>
          <ion-input type="password" [(ngModel)]="form.kreta_totp" placeholder="base32 secret (opcionális)"></ion-input>
        </ion-item>
      </div>
      <div class="gombok">
        <ion-button (click)="ment()"><ion-icon slot="start" name="save-outline"></ion-icon> Mentés</ion-button>
        <ion-button fill="clear" (click)="ujForm()">Új / ürítés</ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Beállított belépések + naplózás -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Beállított belépések ({{ hozzaferesek.length }})</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="vezerlok">
        <ion-item lines="none">
          <ion-checkbox slot="start" [(ngModel)]="dryRun"></ion-checkbox>
          <ion-label>Teszt mód (Validate – nem ír a naplóba)</ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [(ngModel)]="csakTemas"></ion-checkbox>
          <ion-label>Csak a Sulinformban megtartott + témás órát naplózza</ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [(ngModel)]="jegyek"></ion-checkbox>
          <ion-label>A rögzített jegyeket is beírja</ion-label>
        </ion-item>
        <ion-button fill="outline" color="medium" [disabled]="!!ellenorzesFut || szinkronFut || !hozzaferesek.length"
                    (click)="ellenorizMind()">
          <ion-icon slot="start" name="shield-checkmark-outline"></ion-icon>
          Fiókok ellenőrzése
        </ion-button>
        <ion-button [color]="dryRun ? 'primary' : 'danger'" [disabled]="szinkronFut || !hozzaferesek.length" (click)="naplozMind()">
          <ion-icon slot="start" [name]="szinkronFut ? 'hourglass-outline' : 'play'"></ion-icon>
          {{ dryRun ? 'Teszt MINDEN tanárra' : 'ÉLES naplózás MINDENKINEK' }}
        </ion-button>
      </div>

      <!-- Progressbar: manuális ÉS automata (cron) szinkronnál is látszik. -->
      <div class="szinkron-allapot" *ngIf="szinkronFut">
        <div class="fejlec">
          <ion-spinner name="crescent"></ion-spinner>
          <span>
            <b>{{ statusz?.tipus === 'automatikus' ? 'Automatikus szinkron fut' : 'Szinkron fut' }}</b>
            <span *ngIf="statusz?.dryRun"> (teszt)</span>
            — {{ statusz?.kesz || 0 }} / {{ statusz?.osszes || 0 }} tanár
          </span>
          <!-- a manuális és az automatikus futás is megszakítható -->
          <ion-button size="small" color="danger" fill="outline" class="megszakit"
                      *ngIf="statusz?.fut" [disabled]="statusz?.megszakitas || megszakitasFut" (click)="megszakit()">
            <ion-icon slot="start" name="stop-circle-outline"></ion-icon>
            {{ statusz?.megszakitas ? 'Megszakítás folyamatban…' : 'Megszakítás' }}
          </ion-button>
        </div>
        <div class="halvany" *ngIf="statusz?.megszakitas">
          <small>Az épp feldolgozott óra még befejeződik, utána a szinkron leáll. Ha a tanár épp most lép be a KRÉTÁ-ba, ez egy percig is tarthat.</small>
        </div>
        <ion-progress-bar [value]="(statusz?.osszes ? statusz.kesz / statusz.osszes : 0)"></ion-progress-bar>
        <div class="halvany" *ngIf="statusz?.aktualis"><small>Aktuális: {{ statusz.aktualis }} · {{ szazalek }}%</small></div>
        <div class="halvany" *ngIf="!statusz?.aktualis"><small>{{ szazalek }}%</small></div>
      </div>

      <div class="tabla-wrap" *ngIf="hozzaferesek.length; else nincs">
        <table class="lista">
          <thead><tr><th>Tanár</th><th>KRÉTA user</th><th>2FA</th><th>Aktív</th><th>Utolsó futás</th><th>Fiók állapota</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let h of hozzaferesek">
              <td>{{ h.tanar_nev || h.allomany }}</td>
              <td>{{ h.kreta_user }}</td>
              <td>{{ h.van_totp ? 'igen' : '–' }}</td>
              <td>{{ h.aktiv ? '✓' : '✗' }}</td>
              <td class="halvany"><small>{{ h.utolso_futas || '–' }}<br>{{ h.utolso_eredmeny }}</small></td>
              <!-- A fiók állapota külön az utolsó szinkrontól: az a naplózásról szól,
                   ez arról, hogy a belépés MOST működik-e. -->
              <td class="halvany">
                <small *ngIf="h.utolso_ellenorzes === undefined || h.utolso_ellenorzes === null">nincs ellenőrizve</small>
                <small *ngIf="h.utolso_ellenorzes">
                  <b [style.color]="h.utolso_ellenorzes_ok ? '#1a7f37' : '#b42318'">
                    {{ h.utolso_ellenorzes_ok ? 'működik' : 'nem működik' }}
                  </b><br>
                  {{ h.utolso_ellenorzes }}<br>{{ h.utolso_ellenorzes_uzenet }}
                </small>
              </td>
              <td class="jobb">
                <ion-button size="small" fill="outline" color="medium"
                            [disabled]="!!ellenorzesFut || szinkronFut" (click)="ellenoriz(h)">
                  {{ ellenorzesFut === h.allomany ? 'Ellenőrzés…' : 'Ellenőrzés' }}
                </ion-button>
                <ion-button size="small" fill="outline" [disabled]="szinkronFut" (click)="naploz(h)">Naplóz</ion-button>
                <ion-button size="small" fill="clear" (click)="szerkeszt(h)"><ion-icon name="create-outline"></ion-icon></ion-button>
                <ion-button size="small" fill="clear" color="danger" (click)="torol(h)"><ion-icon name="trash-outline"></ion-icon></ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #nincs><p class="halvany">Még nincs beállított tanár-belépés. Vegyél fel egyet fent.</p></ng-template>
    </ion-card-content>
  </ion-card>

  <!-- KRÉTA cím. Minden fenntartónak saját aldomainje van; egy beégetett cím csak
       egyetlen iskolánál jó, máshol a belépés némán a rossz KRÉTÁ-ba próbálna menni. -->
  <ion-card>
    <ion-card-header><ion-card-title>KRÉTA cím</ion-card-title></ion-card-header>
    <ion-card-content>
      <p class="halvany">
        Ide lép be a rendszer naplózáskor és a hozzáférés ellenőrzésekor. Minden fenntartónak
        <b>saját aldomainje</b> van, ezért ezt intézményenként kell megadni. Elég az intézmény
        kódja is (pl. <code>europa2000</code>), abból <code>https://europa2000.e-kreta.hu</code> lesz –
        teljes cím is megadható. Üresen hagyva az alapértelmezett marad.
      </p>
      <div class="vezerlok">
        <ion-input fill="outline" label="KRÉTA cím" labelPlacement="stacked"
                   [(ngModel)]="utemezo.kreta_host"
                   [placeholder]="utemezo.alapertelmezett_host || 'https://valami.e-kreta.hu'"></ion-input>
        <ion-button (click)="mentUtemezo()"><ion-icon slot="start" name="save-outline"></ion-icon> Mentés</ion-button>
      </div>
      <p class="halvany"><small>
        Jelenleg ide lépünk be: <b>{{ utemezo.hasznalt_host || utemezo.alapertelmezett_host }}</b>
        <span *ngIf="!utemezo.kreta_host"> (alapértelmezett – nincs külön beállítva)</span>
      </small></p>
    </ion-card-content>
  </ion-card>

  <!-- Ütemezés -->
  <ion-card>
    <ion-card-header><ion-card-title>Automatikus naplózás (ütemezés)</ion-card-title></ion-card-header>
    <ion-card-content>
      <div class="vezerlok">
        <ion-item lines="none">
          <ion-checkbox slot="start" [(ngModel)]="utemezo.enabled"></ion-checkbox>
          <ion-label>Bekapcsolva</ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-label>Gyakoriság</ion-label>
          <ion-select [(ngModel)]="utemezo.intervallum_perc" interface="popover">
            <ion-select-option [value]="360">6 óránként</ion-select-option>
            <ion-select-option [value]="720">12 óránként</ion-select-option>
            <ion-select-option [value]="1440">Naponta</ion-select-option>
            <ion-select-option [value]="2880">2 naponta</ion-select-option>
            <ion-select-option [value]="10080">Hetente</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [(ngModel)]="utemezo.csak_temas"></ion-checkbox>
          <ion-label>Csak megtartott + témás órát</ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [(ngModel)]="utemezo.jegyek"></ion-checkbox>
          <ion-label>A rögzített jegyeket is beírja</ion-label>
        </ion-item>
        <ion-button (click)="mentUtemezo()"><ion-icon slot="start" name="save-outline"></ion-icon> Mentés</ion-button>
      </div>
      <p class="halvany" *ngIf="utemezo.utolso_futas"><small>Utolsó automatikus futás: {{ utemezo.utolso_futas }} · {{ utemezo.utolso_eredmeny }}</small></p>
    </ion-card-content>
  </ion-card>

  <!-- Eredmény -->
  <ion-card *ngIf="eredmeny">
    <ion-card-header><ion-card-title>Eredmény</ion-card-title></ion-card-header>
    <ion-card-content>
      <p *ngIf="eredmeny.tanarok != null">
        Tanárok: {{ eredmeny.tanarok }} · Naplózva/Validálva: <b>{{ eredmeny.osszes_naplozva }}</b> · Kihagyva: {{ eredmeny.osszes_kihagyva }} · Hiba: {{ eredmeny.osszes_hiba }}
      </p>
      <p *ngIf="eredmeny.naplozva != null">
        {{ eredmeny.tanar }} — Naplózva/Validálva: <b>{{ eredmeny.naplozva }}</b> · Kihagyva: {{ eredmeny.kihagyva }} · Hiba: {{ eredmeny.hiba }}
      </p>
      <p *ngIf="jegyEredmeny">
        Jegyek — {{ jegyEredmeny.ellenorizve ? 'Beírható (teszt)' : 'Beírva' }}:
        <b>{{ (jegyEredmeny.bekuldve || 0) + (jegyEredmeny.ellenorizve || 0) }}</b>
        · Már KRÉTÁ-ban: {{ jegyEredmeny.kretaban || 0 }} · Kihagyva: {{ jegyEredmeny.kihagyva || 0 }}
        · Hiba: {{ jegyEredmeny.hiba || 0 }}
        <span class="halvany" *ngIf="jegyEredmeny.uzenet"><br><small>{{ jegyEredmeny.uzenet }}</small></span>
      </p>
      <div class="tabla-wrap" *ngIf="eredmeny.tetelek?.length">
        <table class="lista">
          <tbody>
            <tr *ngFor="let t of eredmeny.tetelek">
              <td>{{ t.cimke }}</td>
              <td><ion-badge [color]="t.allapot==='naplozva' ? 'success' : (t.allapot==='validalva' ? 'primary' : (t.allapot==='kihagyva' ? 'medium' : 'danger'))">{{ t.allapot }}</ion-badge></td>
              <td class="halvany"><small>{{ t.tema || t.uzenet || '' }}</small></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Jegy-tételek a legutóbbi futásból -->
  <ion-card *ngIf="jegyTetelek.length">
    <ion-card-header><ion-card-title>Jegyek a legutóbbi futásban ({{ jegyTetelek.length }})</ion-card-title></ion-card-header>
    <ion-card-content>
      <div class="tabla-wrap">
        <table class="lista">
          <tbody>
            <tr *ngFor="let t of jegyTetelek">
              <td class="halvany" *ngIf="t.tanar"><small>{{ t.tanar }}</small></td>
              <td>{{ t.cimke }}</td>
              <td><ion-badge [color]="jegyAllapotSzin(t.allapot)">{{ jegyAllapotNev(t.allapot) }}</ion-badge></td>
              <td class="halvany"><small>{{ t.uzenet || '' }}</small></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Jegyek állapota: mi vár átvitelre, és miért nem ment át, ami nem ment -->
  <ion-card *ngIf="jegyAllapot?.tanarok?.length">
    <ion-card-header>
      <ion-card-title>Rögzített jegyek a KRÉTÁ-ban</ion-card-title>
      <ion-card-subtitle>Az idei tanév évközi jegyei{{ jegyAllapot.tankezd ? ' (' + jegyAllapot.tankezd + '-tól)' : '' }}, tanáronként</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="tabla-wrap">
        <table class="lista">
          <thead><tr><th>Tanár</th><th>Összes</th><th>Átment</th><th>Vár</th><th>Kihagyva</th><th>Hiba</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let t of jegyAllapot.tanarok">
              <td>{{ t.nev }}</td>
              <td>{{ t.osszes }}</td>
              <td>{{ t.atment }}</td>
              <td>{{ t.varakozik }}</td>
              <td>{{ t.kihagyva }}</td>
              <td>{{ t.hiba }}</td>
              <td class="halvany"><small *ngIf="!t.van_belepes" style="color:#b42318">nincs KRÉTA-belépése – a jegyei nem kerülnek át</small></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="jegyAllapot.okok?.length" style="margin-top:10px">
        <b>Miért nem ment át?</b>
        <ul class="halvany">
          <li *ngFor="let o of jegyAllapot.okok"><small>{{ o.db }} jegy · {{ o.allapot === 'hiba' ? 'hiba' : 'kihagyva' }}: {{ o.uzenet }}</small></li>
        </ul>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- ═══════════════════════════════════════════════════════════════════════
       ELTÉRÉSEK: a KRÉTÁ-ban is javítani kell.

       A szinkron egyszer viszi át a jegyet, utána nem nyúl hozzá — a KRÉTA Save ÚJ
       értékelést hoz létre, nem módosít, tehát az újraküldés duplikálna. Ezért a
       későbbi javítás és törlés nem jut el oda; ez a lista mondja meg, mi maradt.
       ══════════════════════════════════════════════════════════════════════ -->
  <ion-card *ngIf="elteres?.osszes">
    <ion-card-header>
      <ion-card-title>A KRÉTÁ-ban is javítani kell ({{ elteres.osszes }})</ion-card-title>
      <ion-card-subtitle>Átment jegyek, amiken azóta változtattak</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <p class="halvany" style="margin-top:0">
        Ezek a jegyek <b>már bekerültek a KRÉTÁ-ba</b>, és utána módosultak vagy törlődtek nálunk.
        A rendszer <b>nem küldi ki újra</b> őket (az új jegyet hozna létre, és <b>megduplázná</b>),
        hanem a KRÉTÁ-ban meglévő jegyet <b>módosítja vagy törli</b>, a jegyet beíró tanár nevében.
        Ezt a <b>szinkron magától elvégzi</b> a tanár következő futásakor; ami itt marad, az vagy még
        nem került sorra, vagy a KRÉTA nem engedte (az oka a sorban látszik – 3 sikertelen kör után
        csak akkor próbálja újra, ha a jegyhez nálunk megint hozzányúltak). Kézzel is indítható:
        előbb a <b>Próba</b> megmutatja, pontosan mit írna át, és nem küld semmit. Ha a KRÉTÁ-ban
        közben kézzel már javították, nem nyúl hozzá. Kézi javítás után a pipával vedd le a listáról.
      </p>

      <div style="display:flex; gap:6px; align-items:center; flex-wrap:wrap; margin-bottom:8px">
        <ion-button size="small" fill="outline" (click)="elteresMind(true)">Mind</ion-button>
        <ion-button size="small" fill="clear" (click)="elteresMind(false)">Egyik sem</ion-button>
        <ion-button size="small" color="primary" [disabled]="!elteresJeloltDb || elteresFut"
                    (click)="elteresRendezve()">
          {{ elteresFut ? 'Mentés…' : 'Kijelöltek levétele a listáról (' + elteresJeloltDb + ')' }}
        </ion-button>
        <ion-button size="small" fill="outline" color="tertiary" [disabled]="!elteresJeloltDb || javitasFut"
                    (click)="javitasKretaban(false)">
          {{ javitasFut ? 'Folyamatban…' : 'Próba: javítás a KRÉTÁ-ban (' + elteresJeloltDb + ')' }}
        </ion-button>
        <ion-button size="small" color="danger" [disabled]="!javitasraKesz.length || javitasFut"
                    (click)="javitasKretaban(true)">
          Javítás a KRÉTÁ-ban ({{ javitasraKesz.length }})
        </ion-button>
      </div>

      <div *ngIf="javitasEredmeny?.length" class="tabla-wrap" style="margin-bottom:10px">
        <b>{{ javitasEles ? 'A javítás eredménye' : 'Próba – ezt küldené (a KRÉTÁ-ba nem ment ki semmi)' }}</b>
        <table class="lista">
          <tbody>
            <tr *ngFor="let t of javitasEredmeny">
              <td><ion-icon [name]="t.ok ? 'checkmark-circle' : 'alert-circle'" [color]="t.ok ? 'success' : 'danger'"></ion-icon></td>
              <td>{{ t.cimke }}</td>
              <td>{{ javitasSor(t) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="tabla-wrap" *ngIf="elteres.modositott?.length">
        <table class="lista">
          <thead>
            <tr><th></th><th>Tanár</th><th>Tanuló</th><th>Tantárgy</th><th>Mi változott</th><th>Mikor</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of elteres.modositott">
              <td><ion-checkbox [(ngModel)]="elteresJelolt[r.id]"></ion-checkbox></td>
              <td>{{ r.tanar_nev || r.tanar }}</td>
              <td>{{ r.tanulo_nev || r.oktazon }}<span class="halvany" *ngIf="r.osztaly_nev"> · {{ r.osztaly_nev }}</span></td>
              <td>{{ r.tantargy || '—' }}</td>
              <td>{{ elteresSzoveg(r) }}<div *ngIf="r.javitas_hiba" class="halvany" style="color:var(--ion-color-danger)"><small>Automatikus javítás sikertelen ({{ r.javitas_probalkozas }}×): {{ r.javitas_hiba }}</small></div></td>
              <td class="halvany">{{ r.modositva }}<span *ngIf="r.modositotta"> · {{ r.modositotta }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="elteres.torolt?.length" style="margin-top:12px">
        <b>Nálunk törölve, a KRÉTÁ-ban ott maradt ({{ elteres.torolt.length }})</b>
        <div class="tabla-wrap">
          <table class="lista">
            <thead><tr><th></th><th>Tanár</th><th>Érték</th><th>Dátum</th><th>Téma</th></tr></thead>
            <tbody>
              <tr *ngFor="let r of elteres.torolt">
                <td><ion-checkbox [(ngModel)]="elteresJelolt[r.id]"></ion-checkbox></td>
                <td>{{ r.tanar_nev || r.tanar }}</td>
                <td>{{ r.kuldott_ertek || '—' }}</td>
                <td>{{ r.kuldott_datum || '—' }}</td>
                <td>{{ r.kuldott_tema || '—' }}<div *ngIf="r.javitas_hiba" class="halvany" style="color:var(--ion-color-danger)"><small>Automatikus törlés sikertelen ({{ r.javitas_probalkozas }}×): {{ r.javitas_hiba }}</small></div></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <p class="halvany" style="margin-bottom:0">
        <small>
          Csak azok a jegyek szerepelhetnek itt, amelyeknél tudjuk, <b>mit küldtünk ki</b>.
          A funkció bevezetése előtt átment jegyeknél ez nincs meg, azokat nem tudjuk összevetni —
          inkább nem mutatjuk, mint hogy hamis eltérést jelezzünk.
        </small>
      </p>
    </ion-card-content>
  </ion-card>

  <!-- Napló (audit) -->
  <ion-card *ngIf="log.length">
    <ion-card-header><ion-card-title>Naplózási előzmény</ion-card-title></ion-card-header>
    <ion-card-content>
      <div class="tabla-wrap">
        <table class="lista">
          <thead><tr><th>Idő</th><th>Tanár</th><th>Óra</th><th>Téma</th><th>Állapot</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let l of log">
              <td class="halvany"><small>{{ l.letrehozva }}</small></td>
              <td>{{ l.kreta_user }}</td>
              <td>{{ l.datum }} {{ l.oraszam }}.óra {{ l.osztaly }} {{ l.tantargy }}</td>
              <td>{{ l.tema }}</td>
              <td><ion-badge [color]="l.allapot==='naplozva' ? 'success' : (l.allapot==='visszavonva' ? 'medium' : (l.allapot==='kihagyva' ? 'light' : 'danger'))">{{ l.allapot }}</ion-badge></td>
              <td><ion-button *ngIf="l.allapot==='naplozva' && l.tanitasi_ora_id" size="small" fill="clear" color="medium" (click)="visszavon(l)">Visszavon</ion-button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>
</div>
